import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getToken } from './Common'; // Adjust the path as needed

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      getToken() ? (
        <Component {...props} />
      ) : (
        <Redirect to="/" />
      )
    }
  />
);

export default PrivateRoute;
